//  Copyright (c) 2022 Generated Systems Technologies, Inc. All rights reserved.

import React from "react";
import PageHeader from "../components/PageHeader"

export default function LoggedOut(props) {

  var error = '';

  if (props.location.state !== undefined)
  {
    if (props.location.state.error !== undefined)
    {
      error = props.location.state.error;
    }
  }

  return (
    <div className="LoggedOut">
      <PageHeader title="Logged Out" info={error}/>
    </div>
  );
  
}
